import { render, staticRenderFns } from "./IconGold.vue?vue&type=template&id=3d1d02d9&scoped=true&"
import script from "./IconGold.vue?vue&type=script&lang=js&"
export * from "./IconGold.vue?vue&type=script&lang=js&"
import style0 from "./IconGold.vue?vue&type=style&index=0&id=3d1d02d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1d02d9",
  null
  
)

export default component.exports